import React from "react";

const Impressum = () => {
    return (
        <div className="min-h-screen flex items-center justify-center p-6">
            <div className="bg-white shadow-md rounded-lg max-w-4xl w-full p-6">
                <h1 className="text-2xl font-bold text-gray-800 mb-4">
                    Impressum
                </h1>
                <p className="text-gray-600 mb-4">
                    Angaben gemäß § 5 TMG (Telemediengesetz)
                </p>

                <div className="mb-6">
                    <h2 className="text-lg font-semibold text-gray-800">
                        Kontakt
                    </h2>
                    <p className="text-gray-600">
                        Spyros Gkikas
                        <br />
                        Restaurant En Edem zur Gärtnerklause
                        <br />
                        Kanalstraße 72
                        <br />
                        76356 Weingarten
                        <br />
                        Deutschland
                    </p>
                    <p className="text-gray-600 mt-2">
                        Telefon: +49 7244 9469991
                        <br />
                        E-Mail:{" "}
                        <a
                            href="mailto:info@en-edem.de"
                            className="text-blue-500 hover:underline"
                        >
                            info@en-edem.de
                        </a>
                    </p>
                </div>

                <div className="mb-6">
                    <h2 className="text-lg font-semibold text-gray-800">
                        Umsatzsteuer
                    </h2>
                    <p className="text-gray-600">
                        Umsatzsteuer-Identifikationsnummer gemäß §27 a
                        Umsatzsteuergesetz:
                        <br />
                        DE343257150
                    </p>
                </div>

                <div>
                    <h2 className="text-lg font-semibold text-gray-800">
                        Aufsichtsbehörde
                    </h2>
                    <p className="text-gray-600">
                        Landratsamt Karlsruhe <br />
                        Beiertheimer Allee 2 <br />
                        76137 Karlsruhe <br />
                        <a
                            href="http://www.landkreis-karlsruhe.de"
                            className="text-blue-500 hover:underline"
                        >
                            http://www.landkreis-karlsruhe.de
                        </a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Impressum;
